import { DayPilot } from "@daypilot/daypilot-lite-javascript";
import $ from "jquery";
import moment from "moment";

export default class TimeTableDayView {


    constructor($container) {
        this.$container = $container;
        this.$dataContainer = $('#' + this.$container.data('refid'));
        this.initializeCalendar();
    }

    initializeCalendar() {
        this.readEvents();
        let event_groups = JSON.parse(atob(this.$container.data('eventgroups')));
        this.calendar = new DayPilot.Calendar(this.$container[0], {
            viewType: "Resources",
            cellDuration: 5,
            cellHeight: 8,
            scale: "CellDuration",
            columns: event_groups,
            columnWidthSpec: "Fixed",
            columnWidth: 100,
            timeFormat: 'Clock24Hours',
            startDate: this.$container.data('date'),
            eventMoveHandling: "Disabled",
            eventResizeHandling: "Disabled",
            timeRangeSelectedHandling: "Disabled",
            onEventClicked: function (args) {
                let eventUrl = args.e.data.$element.data('url');
                if (eventUrl) {
                    window.location.href = eventUrl;
                }
            },
        });
        this.calendar.init();

        this.calendar.update({ events: this.events });

    }

    readEvents() {

        this.events = [];
        const $events = $(' article', this.$dataContainer);
        $events.each((index, element) => {

            const $element = $(element);
            const start = moment(element.dataset.start);
            const end = moment(element.dataset.end);
            const title = element.dataset.name;
            const eventgroup = element.dataset.eventgroup;
            const url = element.dataset.url;
            const data = {
                text: title,
                resource: Number(eventgroup),
                barColor: "#eeeeee",
                
                $element: $element,
                start: start.format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS),
                end: end.format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS),
                url: url,
                
            };
            this.events.push(data);
        });
    }

    static mount(selector) {
        const elements = $(selector);
        elements.each(function () {
            new TimeTableDayView($(this));
        })
    }

}

